import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BsArrowRight } from "react-icons/bs";
import { motion } from "framer-motion";
import "./RightsManagement.css";

const HeroSection = ({ headingbefore, mark, headingafter, detail }) => {
  return (
    <section className="rm-hero">
      <div className="bg-abstract-lines"></div>

      <Container>
        <Row className="justify-content-center">
          <Col lg={10}>
            <motion.h1
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              {headingbefore} <span className="text-gradient-orange">{mark}</span> <br />
              {headingafter}
            </motion.h1>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              {detail}
            </motion.h2>
            
            <motion.a
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-get-in-touch"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: 0.4 }}
            >
              Get in touch
              <div className="bg-white rounded-circle d-flex align-items-center justify-content-center text-dark" style={{ width: '24px', height: '24px' }}>
                <BsArrowRight size={14} />
              </div>
            </motion.a>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
